module.exports = __webpack_public_path__ + "img/load.5199fbc1.gif";